import React, { FC } from 'react';
import Pagination from 'antd/lib/pagination';
import './style.scss';
import Props from './typing';
import imgURL from 'lib/imgURL';
import { isCitiTheme } from 'lib/analyticsUtil';

const Index: FC<Props> = (props): JSX.Element => {
  const { currentPage, onPageChange, total, pageSize, showPluralLogo, showSizeChanger = false } = props;
  const isCiti = isCitiTheme();
  return (
    <React.Fragment>
      <div className="pagination-section">
        <Pagination
          defaultCurrent={1}
          pageSize={pageSize || 10}
          size="small"
          current={currentPage}
          total={total}
          onChange={(page, pageSize) => {
            onPageChange(page, pageSize);
          }}
          showSizeChanger={showSizeChanger}
          pageSizeOptions={['10', '20', '50', '100']}
        />
        {showPluralLogo && isCiti && (
          <div className='powered-by-plural'>
            <img src={imgURL['powered-pinelabs-online']} alt='powered by pinelabs online' />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Index;
